import React, { useEffect, useState } from 'react';
import { verificarEmail, marcarEmailVerificado } from '../utils/auth';
import { LogoLockup } from '../components/Icons';

// Página de verificación de correo desde el enlace del registro
// (/verificar?token=...). Verifica al cargar y muestra el resultado.
const VerifyPage: React.FC = () => {
  const token = new URLSearchParams(window.location.search).get('token') || '';
  const [estado, setEstado] = useState<'verificando' | 'ok' | 'error'>('verificando');

  useEffect(() => {
    if (!token) { setEstado('error'); return; }
    verificarEmail(token)
      .then(() => { marcarEmailVerificado(); setEstado('ok'); })
      .catch(() => setEstado('error'));
  }, [token]);

  return (
    <div className="panel-overlay">
      <div className="login-box">
        <LogoLockup height={34} />
        <h2>Verificación de correo</h2>
        {estado === 'verificando' && <p>Verificando…</p>}
        {estado === 'ok' && (
          <>
            <p>✅ Tu correo quedó verificado.</p>
            <a className="p-btn-primary" href="/" style={{ display: 'inline-block', marginTop: 12, textDecoration: 'none' }}>Ir al panel →</a>
          </>
        )}
        {estado === 'error' && (
          <>
            <div className="login-error">El enlace es inválido o venció.</div>
            <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 8 }}>
              Puedes pedir uno nuevo desde el panel (banner "Verifica tu correo").
            </p>
            <a className="p-btn-primary" href="/" style={{ display: 'inline-block', marginTop: 12, textDecoration: 'none' }}>Ir al panel →</a>
          </>
        )}
      </div>
    </div>
  );
};

export default VerifyPage;
